/**
 * Converts a Date instance to a string like 'Apr 17, 2020'.
 * @param date a Date instance
 */
export const dateToShortDate = (date: Date): string => {
    const formatter = new Intl.DateTimeFormat('en', {
        calendar: 'gregory',
        day: 'numeric',
        month: 'short',
        year: 'numeric',
    });

    return formatter.format(date);
};
